module.exports = __webpack_public_path__ + "img/roadmap03.6970285b.png";